export const NAVBAR_MENU_DROPDOWN_CARD_DEFAULTS_V2 = {
  padding: '24px',
  width: 'fit-content',
  overflow: 'hidden',
  borderRadius: '16px',
  background: '#ffffff',
  gap: '16px',
};

export const NAVBAR_MENU_DROPDOWN_FULL_DEFAULTS_V2 = {
  padding: '48px',
  width: '100vw',
  overflow: 'hidden',
  borderRadius: '0px',
  background: '#ffffff',
  gap: '16px',
};

export const NAVBAR_MENU_DROPDOWN_MOBILE_DEFAULTS_V2 = {
  background: '#ffffff',
  padding: '8px 0px',
  gap: '4px',
};
